import { render, staticRenderFns } from "./CardAccountProfile.vue?vue&type=template&id=420b4358&scoped=true&"
import script from "./CardAccountProfile.vue?vue&type=script&lang=js&"
export * from "./CardAccountProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420b4358",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('420b4358')) {
      api.createRecord('420b4358', component.options)
    } else {
      api.reload('420b4358', component.options)
    }
    module.hot.accept("./CardAccountProfile.vue?vue&type=template&id=420b4358&scoped=true&", function () {
      api.rerender('420b4358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/accountdashboard/CardAccountProfile.vue"
export default component.exports